import { useTheme } from "@mui/material";
import { useRef } from "react";

export function JobDescriptionModal({ jobDescription, setJobDescription, setIsJobExperienceChanged }) {
  const theme = useTheme();
  const initialJDRef = useRef(jobDescription);

  const handleChange = (e) => {
    const newJD = e.target.value;
    setJobDescription(newJD);
    setIsJobExperienceChanged(newJD !== initialJDRef.current);
  };

  return (
    <div className="flex flex-col px-5 sm:px-14 pt-8 py-10">
      <label className="font-bold" style={{ color: theme.palette.text }}>Job Description</label>
      <textarea
        value={jobDescription}
        onChange={handleChange}
        aria-label="Enter the job description"
        placeholder="Enter the job description"
        className="w-full mt-3 p-4 border rounded-md font-medium min-h-[300px] max-h-[300px] overflow-y-auto"
        style={{
          borderColor: theme.palette.secondary.v4,
          color: theme.palette.text.dark
        }}
      />
    </div>
  );
}
